import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import style from '../ProductPrice.module.scss.js';

const PriceWrap = ({ highlight, previousPriceNewLine, ...otherProps }) => (jsx("div", { ...otherProps, className: classNames(style['z-product-price__price-wrap'], {
        [style['z-product-price__price-wrap--columnar']]: previousPriceNewLine,
        [style['z-product-price__price-wrap--highlight']]: highlight,
    }) }));
PriceWrap.displayName = 'PriceWrap';

export { PriceWrap };
//# sourceMappingURL=PriceWrap.js.map
